(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7057],{

/***/ 45141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/agency",
      function () {
        return __webpack_require__(19810);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ agency; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75810);
/* harmony import */ var _message_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86428);
/* eslint-disable no-unused-vars */ 


function agency() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_login__WEBPACK_IMPORTED_MODULE_1__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("messageApp", {})
        ]
    });
}


/***/ }),

/***/ 75810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_Abc__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86002);
/* harmony import */ var _mui_icons_material_AccountCircleOutlined__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69436);
/* harmony import */ var _mui_icons_material_LockOutlined__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(63845);
/* harmony import */ var _mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(22961);
/* harmony import */ var _mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(72450);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48452);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79072);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40793);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81401);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(44731);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(80562);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9041);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(77169);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74821);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13264);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70594);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34011);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var _src_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5786);
/* harmony import */ var _next_sitemap_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93060);
/* harmony import */ var _next_sitemap_config__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_next_sitemap_config__WEBPACK_IMPORTED_MODULE_6__);


















var BlockTypo = (0,_mui_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "play",
        opacity: 1,
        fontSize: "1.50rem",
        fontWeight: 700,
        lineHeight: "2.00rem",
        textAlign: "center",
        paddingLeft: 0,
        whiteSpace: "wrap",
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_5__/* .tokens.palette_secondary */ .T.palette_secondary
    };
});
var SignInButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Arial,  sans-serif",
        fontSize: "0.8750em",
        fontWeight: 500,
        textTransform: "none",
        color: "#fff",
        border: "1px, solid  #0A2B3B",
        backgroundColor: "#0A2B3B",
        "&:hover": {
            backgroundColor: "#FF7E24"
        }
    };
});
var defaultTheme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
function AgentLogin() {
    var baseUrl = _next_sitemap_config__WEBPACK_IMPORTED_MODULE_6__.baseUrlApp;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showPassword = ref[0], setShowPassword = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}), loginResponse = ref1[0], setLoginResponse = ref1[1];
    var handleClickShowPassword = function() {
        return setShowPassword(function(show) {
            return !show;
        });
    };
    // formik LoginSchema define
    var LoginSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
        username: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().min(3, "Username must be 3 characters at minimum").required("Username is required"),
        password: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().min(3, "Password must be 3 characters at minimum").required("Password is required")
    });
    //  login api call
    var loginDataSubmit = function(data) {
        var payload = {
            username: data.username,
            password: data.password
        };
        axios__WEBPACK_IMPORTED_MODULE_11__/* ["default"].post */ .Z.post("/api/agents/login", payload).then(function(response) {
            console.log("response", response);
            localStorage.setItem("agent_login_token", response.data.token);
            localStorage.setItem("agent_username", response.data.agentName);
            setLoginResponse(response.data);
            if (response.data.status == true) {
                router.push("/blockquiry_connect/agency/message_app");
            }
        }).catch(function(error) {
            console.error(error);
        });
    };
    // custom input style
    var CustomTextField = (0,_mui_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        "& label.Mui-focused": {
            color: "#0B2B3B"
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#0B2B3B"
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#AFABAC"
            },
            "&.Mui-focused fieldset": {
                borderColor: "#0B2B3B"
            }
        },
        input: {
            height: "50px",
            padding: "0 0 0 5px"
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        theme: defaultTheme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            container: true,
            component: "main",
            sx: {
                height: "100vh"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    item: true,
                    xs: false,
                    sm: 4,
                    md: 6,
                    sx: {
                        backgroundImage: 'url("/b_login_screen.png")',
                        backgroundRepeat: "no-repeat",
                        backgroundColor: "#fff",
                        backgroundSize: "fit",
                        backgroundPosition: "center"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    sm: 8,
                    md: 6,
                    component: _mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z,
                    //   variant="outlined"
                    elevation: 0,
                    square: true,
                    sx: {
                        marginTop: "150px",
                        marginBottom: "150px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            variant: "outlined",
                            elevation: 0,
                            sx: {
                                display: "block",
                                flexDirection: "column",
                                alignItems: "center",
                                my: {
                                    xs: "24px",
                                    md: "24px"
                                },
                                p: {
                                    xs: "16px",
                                    md: "24px"
                                },
                                borderRadius: "8px",
                                width: {
                                    xs: "365px",
                                    md: "465px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 0.25,
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            variant: "rounded",
                                            sx: {
                                                bgcolor: "transparent",
                                                border: "1px solid",
                                                borderColor: _src_tokens__WEBPACK_IMPORTED_MODULE_5__/* .tokens.token_grey_300 */ .T.token_grey_300,
                                                width: "28px",
                                                height: "28px"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockTypo, {
                                                children: "b"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockTypo, {
                                            sx: {
                                                color: _src_tokens__WEBPACK_IMPORTED_MODULE_5__/* .tokens.palette_primary */ .T.palette_primary,
                                                lineHeight: "1.75rem",
                                                letterSpacing: "normal"
                                            },
                                            children: "connect"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    sx: {
                                        color: "#202124",
                                        fontFamily: "Google Sans, Noto Sans Myanmar UI, arial, sans-serif",
                                        fontSize: "24px",
                                        fontWeight: 400,
                                        lineHeight: "1.333rem",
                                        wordBreak: "break-word",
                                        my: "16px",
                                        textAlign: "center"
                                    },
                                    children: "Sign in"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    sx: {
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
                                        initialValues: {
                                            username: "",
                                            password: ""
                                        },
                                        validationSchema: LoginSchema,
                                        onSubmit: function(values, param) {
                                            var setSubmitting = param.setSubmitting;
                                            setSubmitting(false);
                                            loginDataSubmit(values);
                                        },
                                        children: function(param) {
                                            var touched = param.touched, errors = param.errors, values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomTextField, {
                                                        id: "username",
                                                        name: "username",
                                                        label: "User name",
                                                        iconEnd: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Abc__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}),
                                                        error: touched.username && errors.username,
                                                        InputProps: {
                                                            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                                position: "start",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_AccountCircleOutlined__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {})
                                                            }),
                                                            style: {
                                                                height: "45px",
                                                                borderRadius: "4px"
                                                            }
                                                        },
                                                        value: values.username,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        sx: {
                                                            height: "45px",
                                                            width: "100%",
                                                            marginTop: "35px"
                                                        }
                                                    }),
                                                    errors.username && touched.username && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        sx: {
                                                            color: "red",
                                                            marginTop: "5px",
                                                            width: "100%"
                                                        },
                                                        children: errors.username
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomTextField, {
                                                        id: "password",
                                                        name: "password",
                                                        type: showPassword ? "text" : "password",
                                                        iconEnd: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}),
                                                        label: "Password",
                                                        iconStart: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Abc__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}),
                                                        error: touched.password && errors.password,
                                                        InputProps: {
                                                            startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                                position: "start",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_LockOutlined__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {})
                                                            }),
                                                            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                                position: "end",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                                                                    onClick: handleClickShowPassword,
                                                                    edge: "end",
                                                                    children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {})
                                                                })
                                                            }),
                                                            style: {
                                                                height: "45px",
                                                                borderRadius: "4px"
                                                            }
                                                        },
                                                        value: values.password,
                                                        onChange: handleChange,
                                                        onBlur: handleBlur,
                                                        sx: {
                                                            height: "45px",
                                                            width: "100%",
                                                            marginTop: "35px"
                                                        }
                                                    }),
                                                    errors.password && touched.password && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        sx: {
                                                            color: "red",
                                                            marginTop: "5px",
                                                            width: "100%"
                                                        },
                                                        children: errors.password
                                                    }),
                                                    loginResponse.status == false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        sx: {
                                                            color: "red",
                                                            marginTop: "8px",
                                                            fontWeight: "500"
                                                        },
                                                        children: loginResponse.message
                                                    }) : "",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignInButton, {
                                                        type: "submit",
                                                        fullWidth: true,
                                                        sx: {
                                                            mt: "40px",
                                                            mb: "8px"
                                                        },
                                                        children: "Sign In"
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (AgentLogin);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,3874,1057,5443,7847,4885,3842,3517,4540,3835,1816,5426,877,2390,3408,9073,8346,594,4951,7155,1199,112,8573,9643,2227,9407,1145,3778,3771,1831,7452,752,4433,9016,9774,2888,179], function() { return __webpack_exec__(45141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);